module.exports = __webpack_public_path__ + "static/home1-special-product-columns-058b231f75a30f9f1fb24b47accc32a2.jpg";